import { IGameCategoriesContext, IFilterValues } from './gameCategoriesContext';

export enum GameCategoriesActionTypes {
	SET_GAME_CATEGORIES = 'SET_GAME_CATEGORIES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetGameCategories {
	type: GameCategoriesActionTypes.SET_GAME_CATEGORIES;
	payload: {
		gameCategories: IGameCategoriesContext['gameCategories'];
		typeOfModalWindow: IGameCategoriesContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: GameCategoriesActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IGameCategoriesContext['searchString'];
	};
}

interface IResetSelectedControls {
	type: GameCategoriesActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: GameCategoriesActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IGameCategoriesContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: GameCategoriesActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IGameCategoriesContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: GameCategoriesActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IGameCategoriesContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: GameCategoriesActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IGameCategoriesContext['IDForDeletion'];
		typeOfModalWindow: IGameCategoriesContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: GameCategoriesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IGameCategoriesContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: GameCategoriesActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TGameCategoriesAction =
	| ISetGameCategories
	| IChangeSearchString
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
